import React from 'react'

type Props = { category?: string | null }

export function EvidenceArtifactCategoryBadge({ category }: Props) {
  if (!category) return <span>—</span>
  return (
    <span className="inline-flex rounded px-2 py-0.5 text-xs font-medium bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200">
      {category.replace(/_/g, ' ')}
    </span>
  )
}
